/* paginagewicht 2026-11-04: filteren, sorteren en bladeren zonder paginaherlading (uit snippets/rabe-live-filters). Geladen met defer; soort en sectie-id komen uit de scripttag. */
(function () {
  var ME = document.currentScript;
  var ZOEK = ME.getAttribute('data-soort') === 'zoeken';
  var SECTION_ID = ME.getAttribute('data-sid');
  var FORM_ID = ZOEK ? 'SearchFilters' : 'CollectionFilters';
  var layout = document.querySelector(ZOEK ? '.zk .search-layout' : '.collection-layout');
  if (!layout || !window.fetch || !window.DOMParser || !window.history || !window.URLSearchParams) return;
  var PRIJS = '.price-filter input[type="number"]';
  var ctrl = null, seq = 0, tPlan = null, tPrijs = null, prijsWacht = false, laatsteZoek = location.search;

  function form() { return document.getElementById(FORM_ID); }
  function sortSel() { return document.querySelector('.sort-form select'); }
  function hoortBijForm(el) { return el && el.form && el.form.id === FORM_ID; }

  function params(f) {
    var qs = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (v !== '' && v !== null) qs.append(k, v); });
    var s = sortSel();
    if (s && s.value && s.value !== 'relevance') qs.set('sort_by', s.value);
    return qs;
  }
  function formUrl(f) {
    var base = (f.getAttribute('action') || location.pathname).split('?')[0];
    var q = params(f).toString();
    return base + (q ? '?' + q : '');
  }

  /* Open en dichte filtergroepen blijven zoals de klant ze had. */
  function sleutel(d) {
    var s = d.querySelector('summary'); if (!s) return '';
    var t = s.querySelector('span') || s;
    return t.textContent.replace(/\s+/g, ' ').replace(/\s*\d+\s*$/, '').trim();
  }
  function openStand(side) {
    var o = {};
    side.querySelectorAll('details').forEach(function (d) { var k = sleutel(d); if (k) o[k] = d.open; });
    return o;
  }
  function focusStand(side) {
    var a = document.activeElement;
    if (!a || !side.contains(a)) return null;
    var c = ['price-slider__lo', 'price-slider__hi', 'mf-close', 'zk-mf-close'].filter(function (x) { return a.classList.contains(x); })[0];
    return { cls: c, name: a.getAttribute('name'), type: a.type, value: a.value };
  }
  function focusTerug(st, side) {
    if (!st) return;
    var el = null;
    if (st.cls) el = side.querySelector('.' + st.cls);
    else if (st.name) el = Array.prototype.filter.call(side.querySelectorAll('input'), function (i) {
      return i.name === st.name && (i.type !== 'checkbox' || i.value === st.value);
    })[0];
    if (!el) return;
    if (el.type === 'number') el.value = st.value;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    /* cursor achteraan, anders typt de klant na een korte pauze voor zijn eigen cijfers */
    if (el.type === 'number') { try { var n = el.value.length; el.type = 'text'; el.setSelectionRange(n, n); el.type = 'number'; } catch (e) {} }
  }

  function toepassen(doc) {
    /* paginagewicht: de sprite bevat alleen gebruikte symbolen; een nieuwe tegel na filteren krijgt hier zijn symbool */
    var sn = doc.querySelector('svg.mk-sprite[data-mk-sub]'), so = document.querySelector('svg.mk-sprite[data-mk-sub]');
    if (sn && so) Array.prototype.forEach.call(sn.children, function (s) { if (s.id && !document.getElementById(s.id)) so.appendChild(document.importNode(s, true)); });
    var ns = doc.querySelector('.collection-sidebar'), os = layout.querySelector('.collection-sidebar');
    if (!ns || !os) return false;
    if (ZOEK) {
      var nr = doc.querySelector('.search-layout .collection-results'), or = layout.querySelector('.collection-results');
      if (!nr || !or) return false;
      var nc = doc.querySelector('.zk-count'), oc = or.querySelector('.zk-count');
      if (nc && oc) oc.replaceWith(nc);
      Array.prototype.slice.call(or.children).forEach(function (c) { if (!c.classList.contains('collection-toolbar')) c.remove(); });
      Array.prototype.slice.call(nr.children).forEach(function (c) { if (!c.classList.contains('collection-toolbar')) or.appendChild(c); });
      var nz = doc.querySelector('.zk-cats'), oz = document.querySelector('.zk-cats');
      if (oz && nz) oz.replaceWith(nz); else if (oz) oz.remove(); else if (nz) layout.parentNode.insertBefore(nz, layout);
    } else {
      var nb = doc.querySelector('.coll-results-body'), ob = layout.querySelector('.coll-results-body');
      if (!nb || !ob) return false;
      ob.replaceWith(nb);
      var nh = doc.querySelector('.collection-hub--hybrid'), oh = layout.querySelector('.collection-hub--hybrid');
      if (oh && !nh) oh.remove(); else if (nh && !oh) layout.appendChild(nh);
    }
    var open = openStand(os), foc = focusStand(os);
    var osp = os.querySelector('.filters-panel'), nsp = ns.querySelector('.filters-panel');
    var ost = osp ? osp.scrollTop : 0;
    os.replaceWith(ns);
    ns.querySelectorAll('details').forEach(function (d) { var k = sleutel(d); if (k && Object.prototype.hasOwnProperty.call(open, k)) d.open = open[k]; });
    if (nsp && osp) {
      if (ost) nsp.scrollTop = ost;
      ['role', 'aria-modal'].forEach(function (x) { if (osp.hasAttribute(x)) nsp.setAttribute(x, osp.getAttribute(x)); });
    }
    focusTerug(foc, ns);
    /* sorteerformulier staat buiten het ververste deel: gelijk houden met de nieuwe stand */
    var nf = doc.querySelector('.sort-form'), of = document.querySelector('.sort-form');
    if (nf && of) {
      of.querySelectorAll('input[type="hidden"]').forEach(function (i) { i.remove(); });
      nf.querySelectorAll('input[type="hidden"]').forEach(function (i) { of.insertBefore(i, of.firstChild); });
      var a = nf.querySelector('select'), b = of.querySelector('select');
      if (a && b && document.activeElement !== b) b.value = a.value;
    }
    return true;
  }

  function annuleer() {
    clearTimeout(tPlan);
    if (ctrl) { ctrl.abort(); ctrl = null; }
    seq++;
    layout.classList.remove('is-loading');
  }

  /* De laatste klik wint: een lopend verzoek wordt afgebroken, de vinkjes in het formulier zijn al bijgewerkt. */
  function swap(url, o) {
    var u; try { u = new URL(url, location.href); } catch (e) { location.href = url; return; }
    if (u.origin !== location.origin || u.pathname !== location.pathname) { location.href = u.href; return; }
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var mijn = ++seq;
    layout.classList.add('is-loading');
    var fu = new URL(u.href); fu.searchParams.set('section_id', SECTION_ID);
    fetch(fu.href, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (html) {
      if (mijn !== seq) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (!toepassen(doc)) { location.href = u.href; return; }
      if (window.rabeMfSync) window.rabeMfSync();
      if (o.push) { try { history.pushState({ rabeAjax: true }, '', u.href); } catch (e) {} }
      laatsteZoek = location.search;
      init();
      document.dispatchEvent(new CustomEvent('rabe:prices-updated'));
      if (o.scroll) { var top = layout.getBoundingClientRect().top + window.scrollY - 110; window.scrollTo({ top: top, behavior: 'smooth' }); }
    }).catch(function (e) {
      if (e && e.name === 'AbortError') return;
      if (mijn === seq) location.href = u.href;
    }).then(function () {
      if (mijn === seq) layout.classList.remove('is-loading');
    });
  }

  function plan(ms) {
    clearTimeout(tPlan); clearTimeout(tPrijs); prijsWacht = false;
    tPlan = setTimeout(function () {
      var f = form(); if (!f) return;
      var v = f.querySelectorAll(PRIJS);
      if (v.length > 1 && v[0].value !== '' && v[1].value !== '' && parseFloat(v[0].value) > parseFloat(v[1].value)) { var x = v[0].value; v[0].value = v[1].value; v[1].value = x; }
      swap(formUrl(f), { push: true });
    }, ms === undefined ? 120 : ms);
  }

  function prijsNu(f, klaar) {
    var v = f.querySelectorAll(PRIJS);
    /* min boven max tijdens het typen: wachten tot de klant het veld verlaat */
    if (!klaar && v.length > 1 && v[0].value !== '' && v[1].value !== '' && parseFloat(v[0].value) > parseFloat(v[1].value)) return;
    plan(0);
  }

  function initSlider(sl) {
    var lo = sl.querySelector('.price-slider__lo'), hi = sl.querySelector('.price-slider__hi'), fill = sl.querySelector('.price-slider__fill');
    var pf = sl.closest('.price-filter'), nums = pf ? pf.querySelectorAll('input[type="number"]') : [];
    var max = parseInt(sl.getAttribute('data-max'), 10) || 1;
    function vul(a, b) {
      fill.style.left = (Math.min(a, b) / max * 100) + '%';
      fill.style.right = (100 - Math.max(a, b) / max * 100) + '%';
    }
    function paint() {
      var a = parseInt(lo.value, 10), b = parseInt(hi.value, 10);
      if (a > b) { if (document.activeElement === lo) { b = a; hi.value = b; } else { a = b; lo.value = a; } }
      vul(a, b);
      if (nums[0]) nums[0].value = a > 0 ? a : '';
      if (nums[1]) nums[1].value = b < max ? b : '';
    }
    lo.addEventListener('input', paint); hi.addEventListener('input', paint);
    lo.addEventListener('change', function () { plan(250); }); hi.addEventListener('change', function () { plan(250); });
    /* typen schrijft alleen de schuif bij, nooit terug in het veld waarin de klant bezig is */
    Array.prototype.forEach.call(nums, function (n, i) {
      n.addEventListener('input', function () {
        var v = parseInt(n.value, 10); if (isNaN(v)) v = i === 0 ? 0 : max;
        (i === 0 ? lo : hi).value = Math.max(0, Math.min(max, v));
        vul(parseInt(lo.value, 10), parseInt(hi.value, 10));
      });
    });
    var a0 = parseInt(lo.value, 10), b0 = parseInt(hi.value, 10); vul(a0, b0);
  }

  function init() {
    if (window.rabeInitFilters) window.rabeInitFilters();
    layout.querySelectorAll('.price-slider').forEach(initSlider);
  }

  window.rabeSortLive = function (sel) {
    var f = form(), url;
    if (f) {
      var h = f.querySelector('input[name="sort_by"]'); if (h) h.value = sel.value;
      url = formUrl(f);
      var u0 = new URL(url, location.href); u0.searchParams.set('sort_by', sel.value); url = u0.href;
    } else {
      var u1 = new URL(location.href); u1.searchParams.set('sort_by', sel.value); u1.searchParams.delete('page'); url = u1.href;
    }
    clearTimeout(tPlan); clearTimeout(tPrijs); prijsWacht = false;
    swap(url, { push: true });
    return true;
  };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.id !== FORM_ID) return;
    e.preventDefault(); plan();
  });
  /* De categoriepagina vuurt bij een vinkje zelf het formulier af (rabeInitFilters); de zoekpagina doet het hier. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (hoortBijForm(t) && t.matches(PRIJS)) { if (prijsWacht) { prijsWacht = false; clearTimeout(tPrijs); prijsNu(t.form, true); } return; }
    if (!window.rabeInitFilters && hoortBijForm(t) && t.matches('input[type="checkbox"]') && !t.disabled) plan();
  });
  document.addEventListener('input', function (e) {
    var n = e.target;
    if (!hoortBijForm(n) || !n.matches(PRIJS)) return;
    annuleer();
    prijsWacht = true;
    clearTimeout(tPrijs);
    tPrijs = setTimeout(function () { prijsNu(n.form, false); }, 800);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || !layout.contains(a)) return;
    if (a.classList.contains('mk-tile--soort') || a.classList.contains('mk-soort__all')) return;
    var wissen = a.matches('.filters-panel__heading a, .filters-panel__actions .button--ghost');
    var isFilter = wissen || a.matches('.mk-tile, .mk-row__clear, .active-filter-chip, .filter-modal a');
    var isPage = !!a.closest('.pagination');
    if (!isFilter && !isPage) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    var doel = a.href;
    if (wissen) {
      var s = sortSel();
      var u = new URL(doel, location.href);
      if (s && s.value && s.value !== 'relevance' && !u.searchParams.has('sort_by')) u.searchParams.set('sort_by', s.value);
      doel = u.href;
    }
    clearTimeout(tPlan); clearTimeout(tPrijs); prijsWacht = false;
    swap(doel, { push: true, scroll: isPage });
  });
  window.addEventListener('popstate', function () {
    if (location.search === laatsteZoek) return;
    swap(location.href, { push: false });
  });
  init();
})();
